import React from "react";
import { Provider, Subscribe, Container } from "unstated";
import axios from 'axios';
import CampaignStore from '../stores/CampaignStore';
import AuthStore from '../stores/AuthStore';
import SnackBarStore from '../stores/SnackBarStore';
import NotificationStore from '../stores/NotificationStore';
// Create a Container for our React Context. This container will
// hold state and methods just like a react component would:
export class StoreContainer extends Container {
  constructor() {
    super();
    // The state will be available to any component we inject
    // the Container instance into
    this.state = this.initialState();
    this.functions = {};
    //Add Stores state
    this.addStore('auth', AuthStore);
    this.addStore('snackbar', SnackBarStore);
    this.addStore('campaign', CampaignStore);
    this.addStore('notifications', NotificationStore);
  }
  //Bind stores method to store provider
  bindStoreToProvider(storeKey, functions) {
    this[storeKey] = {};
    for (let func in functions) {
      this[storeKey][func] = functions[func].bind(this);
    }
  }
  //Add Store
  addStore(storeKey, storeObject) {
    this.state[storeKey] = typeof (storeObject.state) === 'function' ? storeObject.state() : storeObject.state;
    this.bindStoreToProvider(storeKey, storeObject.functions);
  }
  initialState() {
    //Setup AXIOS
    if (localStorage.hasOwnProperty('user'))
      axios.defaults.headers.common['Authorization'] = "Bearer " + JSON.parse(localStorage.getItem('user')).token
    //Return Initial Data
    return {}
  }
}

// Following the Singleton Service pattern (think Angular Service),
// we will instantiate the Container from within this module
const GlobalStore = new StoreContainer();

// Then we will wrap the provider and subscriber inside of functional
// React components. This simplifies the resuse of the module as we
// will be able to import this module as a depenency without having
// to import Unstated and/or create React Contexts  manually in the
// places that we want to Provide/Subscribe to the Store Service.
export const StoreProvider = props => {
  // We leave the injector flexible, so you can inject a new dependency
  // at any time, eg: snapshot testing
  return <Provider inject={props.inject || [GlobalStore]}>{props.children}</Provider>;
};

export const StoreSubscribe = props => {
  // We also leave the subscribe "to" flexible, so you can have full
  // control over your subscripton from outside of the module
  return <Subscribe to={props.to || [GlobalStore]}>{props.children}</Subscribe>;
};

export default GlobalStore;

// IMPORT NOTE:
// With the above export structure, we have the ability to
// import like this:

// import Store, {StoreProvider, StoreSubscribe, StoreContainer}

// Store: Singleton Store instance, exported as default.
//      Contains your instantiated .state and methods.

// StoreProvider: Context Provider...
//      Publishes your React Context into the top of the
//      React App into the component tree.

// StoreSubscribe: Context Subsriber...
//      Subscribes to the higher Context from any place
//      lower than the point at which the Context was provided.

// StoreContainer:Context Container Class...
//      Used to instantiate new copy of your service if so desired.
//      Can be used for testing, or subsrcibing your class to a new
//      data source that uses the same data model/methods.
